import React from 'react'
import {
  ContextToolbar,
  PanelPermissions,
  useTraversal,
} from '@guillotinaweb/react-gmi'

import { AuditLogTab } from '../../../common/auditlog'
import { Content } from './Content'
import { Schedule } from './Schedule'
import { TabsPanelWithLock } from '../../../components/tab-panel-with-lock'

import './styles.css'

const tabs = {
  Content,
  Schedule,
  Permissions: PanelPermissions,
  AuditLog: AuditLogTab,
}

const tabsPermissions = {
  Content: 'guillotina.ViewContent',
  Schedule: 'guillotina.ViewContent',
  Permissions: 'guillotina.SeePermissions',
  AuditLog: 'vinissimus.ViewLogs',
}

export function NewsletterView(props) {
  const ctx = useTraversal()
  const calculated = ctx.filterTabs(tabs, tabsPermissions)

  return (
    <TabsPanelWithLock
      tabs={calculated}
      currentTab="Content"
      editableTabs={['Content', 'Schedule']}
      rightToolbar={<ContextToolbar {...props} />}
      {...props}
    />
  )
}
